exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* span{\r\n    color: red;\r\n} */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/solar-pv/solar-pv.component.css
// module id = ../../../../../src/app/components/solar-pv/solar-pv.component.css
// module chunks = 0